import {createSlice, PayloadAction}			from '@reduxjs/toolkit';

import {RootState}							from '../../app/store';
import {SettingForceHeader, SettingsState}	from './interface';


const initialState: SettingsState = {
	lang:		'fr'
};


export const settingsReducer = createSlice({
	name:     'settings',
	initialState,
	reducers: {
		setLang: (state, action: PayloadAction<string>) => {
			state.lang = action.payload;
		},
		setHeader: (state, action: PayloadAction<SettingForceHeader>) => {
			state.forceHeaderFunction = action.payload;
		},
		clearHeader: (state) => {
			state.forceHeaderFunction = undefined;
		}
	}
});

export const {setLang, setHeader, clearHeader} = settingsReducer.actions;

export const lang = (state: RootState) => state.settings.lang;

export default settingsReducer.reducer;
